import React, { useCallback, useContext, useState,useEffect,useMemo, useReducer} from "react";
import { ModalNextContext } from '@jutro/components';
import { ViewModelServiceContext,ViewModelForm,useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, IntlContext ,useTranslator } from '@jutro/locale';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { LoaderExt } from 'gw-components-platform-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _, { isArguments, random } from "lodash";
import moment from 'moment';
import  usecpmiAnalytics from '../../../../account-management/src/hooks/usecpmiAnalytics';
import useGoogleAnalytics from "../../../../account-management/src/hooks/useGoogleAnalytics";
import PayrollService from "../../../capabilities/cpmi-capability-payroll/services/PayrollService";
import metadata from "./CPMIStartPayroll.metadata.json5";
import styles from "./CPMIStartPayroll.module.scss";
import messages from "./CPMIStartPayroll.messages";
import PayrollReview from '../PayrollReview/PayrollReview';
import CPMIClassCodeComponent from "./CPMIClassCodeComponent/CPMIClassCodeComponent";
// import CPMIClassCodeComponentGL from "../../../capabilities-react/cpmi-capability-payrollreporting-react/CPMIStartPayrollGL/CPMIClassCodeComponent/CPMIClassCodeComponent";

import { Link } from '@jutro/router';

function CPMIStartPayroll(props) {
    const ModalNext=useContext(ModalNextContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const { authHeader } = useAuthentication();
    const [payrollVM,setPayrollVM] = useState([])
    const[trackPageView,trackEvent] = usecpmiAnalytics();
    const[trackGAPageView] = useGoogleAnalytics();
    const [payrollData,setPayrollData]=useState({})
    const { refreshData } = useDataRefresh()
    const [isLoading, setIsLoading] = useState(false)
    const [draftmsg,setdraftmsg]=useState(false)
    const [warningmsg,setwarningmsg]=useState(false);
    const [reviewData,setreviewData]=useState([])
    const [viewStartPage,setviewStartPage]=useState(true)
    const [stateData,setstateData]=useState([])
    const [totalData,settotalData]=useState({
        empCount:0,
        grossAmount:0
    })
    const [randomNumber,setrandomNumber]=useState(0);
    const [blankValues,setblankValues]=useState(false)
    const [refresh,setRefresh]=useState(null)
    const [PremptionError,setShowPremptionError]=useState(false)
    const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
    const {
        history,
        location:{
            state,
            state:{appValue}
        }
    }=props
    const [startPayrollButtonClicked,setstartPayrollButtonClicked] = useState(props.history.location.state.page)
    const [disabledNext,setdisabledNext]=useState(false)
    let stateEmployeeTotal = 0;
    let stateGrossPayTotal = 0;

    let longshoreAndHarborEmployeeTotal = 0;
    let longshoreAndHarborGrossPayTotal = 0;

    let admiraltyLawEmployeeTotal = 0;
    let admiraltyLawGrossPayTotal = 0;

    let FELAEmployeeTotal = 0;
    let FELAGrossPayTotal = 0;

    const arryGowrningLaw = [];
    const uniqueGowrningLaw = [];
    

    useEffect(() => {
        trackPageView("start payroll","/startpayroll")
    },[])

    useEffect(() => {
        trackGAPageView("/startpayroll","Start/Edit Payroll")
    },[])

    useEffect(()=>{},[randomNumber])

    useEffect(()=>{
        setIsLoading(true)
        getInProgressReportPeriod();
        
        //  setFormattedPayrollData(payrollData);
        //       setFinalpayrollData(payrollData);
    },[refresh])

    const CheckforPremption = useCallback((res)=>{
        if(res.hasPreemptions){
            setShowPremptionError(true)
        }
        else{
            setShowPremptionError(false)
        }
    },[])

    // useEffect(()=>{

    // },[stateEmployeeTotal,stateGrossPayTotal,longshoreAndHarborEmployeeTotal,longshoreAndHarborEmployeeTotal,admiraltyLawEmployeeTotal,admiraltyLawGrossPayTotal,FELAEmployeeTotal,FELAGrossPayTotal])


    const setFinalpayrollData=useCallback((payroll)=>{
        const data ={
            stateEmpCount:0,
            stateGrossPayAmount:0,
            totalEmpCount:0,
            totalGrossPayAmount:0,

        }
        const tempstates={
            empCount:0,
            grossAmount:0
        }
        for (const [key, count] of Object.entries(tempstates)) {
            stateData.push(...Array.from({length: count}).fill(key));
        }
        let flag=false
        payroll.states.forEach((states,index)=>{
            data.stateEmpCount=0
            data.stateGrossPayAmount=0
            states.coveredEmployees.forEach((emp)=>{
                data.stateEmpCount+=parseInt(emp.auditedEmployeeCount)||0
                data.totalEmpCount+=parseInt(emp.auditedEmployeeCount)||0
                data.stateGrossPayAmount+=parseInt(emp.auditedPayrollAmount)||0
                data.totalGrossPayAmount+=parseInt(emp.auditedPayrollAmount)||0
                if(_.isNaN(parseInt(emp.auditedPayrollAmount))){
                    flag=true
                }
            })
            
            stateData[index]={empCount:data.stateEmpCount,grossAmount:data.stateGrossPayAmount}
            setstateData(stateData)
        })
       
        if(flag){
            setdisabledNext(true)
        }else{
            setdisabledNext(false)
        }
        settotalData({empCount:data.totalEmpCount,grossAmount:data.totalGrossPayAmount})
        setrandomNumber(Math.random()*10)
    },[stateData])

    const setFormattedPayrollData=useCallback((payroll)=>{

       
        const  result = payroll.coveredEmployees.reduce((r, a) => {
            r[a.location.address.state] = r[a.location.address.state] || [];
            r[a.location.address.state].push(a);
            return r;
        }, Object.create(null));
        const tempStates=[];
        for (const [key, value] of Object.entries(result)) {
            tempStates.push({
                stateCode:key,
                coveredEmployees:value
            })
        }
        payroll.states=tempStates;
        setPayrollData(payroll);
    },[])

    const getInProgressReportPeriod=useCallback(()=>{
        if(appValue==="PE"){
            PayrollService.PEgetInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{
                setPayrollData(res);
                CheckforPremption(res);
                setFinalpayrollData(res)}).finally(()=>{setIsLoading(false)})
        }
        else{
            PayrollService.getInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{setFormattedPayrollData(res);CheckforPremption(res);setFinalpayrollData(res)}).finally(()=>{setIsLoading(false)})
            // PayrollService.getInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{setPayrollData(res);}).finally(()=>{setIsLoading(false)})
          
        }
        
    },[CheckforPremption, appValue, authHeader, setFinalpayrollData, setFormattedPayrollData, state.jobNumber])

    const getStates=useCallback((statecode)=>{
       
        if(statecode!==undefined && statecode!==' ' && viewModelService!==undefined){
            const typeList = viewModelService.create(
                {},
                'pc',
                'edge.capabilities.address.dto.AddressDTO'
            );
            const availableStates = typeList.state.aspects.availableValues
            const statename = availableStates.filter((s)=>{return s.code===statecode})
                .map((s)=>{return s.name})
            const res = translator({
                id:statename[0],
                defaultMessage:statename[0]
            })
            return  res; 
        }
        return ' '
    },[viewModelService])

    const setUpdatedPayrollData=useCallback((id,updatedCoveredEmployees)=>{
        id = id.split(/(\d+)/)
        
        
        _.set(payrollData,`states[${id[1]}].coveredEmployees`,updatedCoveredEmployees)
        setPayrollData(payrollData)
        setFinalpayrollData(payrollData)

        payrollData.states.forEach((states)=>{
            states.coveredEmployees.forEach((emp)=>{
                if(emp.auditedPayrollAmount>payrollData.totalEstimatedPayrollThreshold){
                    setwarningmsg(true)
                    return null;
                }
                setwarningmsg(false)
                    
            })
        })
        setblankValues(false)
        setrandomNumber(Math.random()*10)
        

    },[payrollData])

    

    const getPayrollData=useCallback(()=>{
        if(appValue==='PE'){
            const states = payrollData.states
            return states
        }
        return payrollData.states;
        
        
    },[appValue, payrollData.states])

    const handleRefresh = useCallback(()=>{
        setRefresh(Math.random()*10)
    },[])

    const handleChangetoZero = useCallback(()=>{
        setblankValues(true)
        setrandomNumber(Math.random()*10)
    },[blankValues])

    const getsaveDraftMsg = useCallback(() =>{
        if(appValue==="PE"){
            return <>Your information has been saved! Please click<button className={styles.draftmsg} onClick={()=>{history.push({pathname:props.location.pathname})}}>back</button>to go to previous screen</>
        }
        return <>Your information has been saved! Please click <Link to='/payroll-reporting/list/report'>back</Link> to go to previous screen</>
    },[appValue, history, state.policyNumber,props.location.pathname])

    const updateAuditReport=useCallback(async()=>{
        
        if(appValue==="PE"){
            await PayrollService.PEupdateAuditReport(payrollData,authHeader)
                .then(()=>{
                    setdraftmsg(true);
                })
                .catch(()=>{
                    ModalNext.showAlert({
                        //title: messages.draftErrorMessage,
                        title: (
                            <p className={styles.draftMsg}>
                                {translator(messages.draftErrorMessage)}
                            </p>
                        ),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.close
                    }).catch(_.noop);
                })
        }
        else{
            await PayrollService.updateAuditReport(payrollData,authHeader)
                .then(()=>{
                    setdraftmsg(true);
                })
                .catch(()=>{
                    ModalNext.showAlert({
                        
                        title: (
                            <p className={styles.draftMsg}>
                                {translator(messages.draftErrorMessage)}
                            </p>
                        ),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.close
                    }).catch(_.noop);
                })
        }
    },[ModalNext, appValue, authHeader, payrollData])

    const handleCancel = useCallback(() => {
        ModalNext.showConfirm({
            title: messages.startpagecancelChangeTitle,
            message: messages.startpagecancelChangeMessage,
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel
        }).then((results) => {
            if(results === 'confirm'){
                if(appValue==="PE")
                {
                    history.push(props.location.pathname)
                }
                else{
                    history.go(-1)
                }
            }
        }, _.noop);
    },[ModalNext, appValue, history, props.location.pathname])

    const getreportingperioddata=useCallback(()=>{
        if(!_.isEmpty(payrollData)){
            const startDate=moment(payrollData.reportPeriodStart).format('MM/DD/YYYY')
            const endDate=moment(payrollData.reportPeriodEnd).format('MM/DD/YYYY')
            return `${startDate} - ${endDate}`
        }
        return " "
    },[payrollData])


    const handleReview =useCallback(async()=>{
        setIsLoading(true)
        
        payrollData?.coveredEmployees?.map((item)=>{
            if(item?.auditedEmployeeCount===undefined){
                item.auditedEmployeeCount=0;
            }
        })
        if(appValue==="PE"){
           
            await PayrollService.PEcalculatePremiumsForReport(payrollData,authHeader).then((result)=>{  
                setPayrollData(result);
                setreviewData(result);
                setviewStartPage(false);
                setIsLoading(false);
            })
        }
        else{

            await PayrollService.calculatePremiumsForReport(payrollData,authHeader).then((result)=>{
                setIsLoading(false)
                return history.push({
                    pathname: `/payroll-reporting/review`,
                    state: {
                        data: result,
                        appValue:'CE'
                        
                      
                    },
                });
            })

            // await PayrollService.calculatePremiumsForReport(payrollData,authHeader).then((result)=>{
            //     setPayrollData(result);
            //     setreviewData(result)
            //     setviewStartPage(false)
            // })

        }
    },[appValue, authHeader, history, isLoading, payrollData])

    // const renderClassNameForClassCode=useCallback(()=>{
    //     let classNameV = '';
    //     if(appValue ==='CE'){
    //         // eslint-disable-next-line no-const-assign
    //         classNameV = "CEclassCodeClClass"
    //     } 
    //     return classNameV;
    // },[appValue])

    const handlepremitionCancelBtn=useCallback(()=>{
        ModalNext.showConfirm({
            title:"Cancel payroll reporting update",
            message:"Are you sure you want to cancel your payroll reporting changes?",
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel,
        }).then((results) => {
            if (results === 'confirm') {
                history.go(-1);
            }
        }, _.noop);
    },[ModalNext, history])


    const generateOverrides = useMemo(() => {

        if(_.isEmpty(payrollData)){
            return null
        }

        console.log(payrollData.states);

        payrollData.states.sort((a, b)=> {
            const createSortKey = (p)=> { return `${p.stateCode}`}
            return createSortKey(a) > createSortKey(b) ? 1 : -1
        })

        let overrides={}
        if(payrollData.states!==undefined)
        {
            overrides = payrollData.states.map((item, index) => {

                const result = [];
        
                const holder = {};

                // eslint-disable-next-line no-shadow
                
                item.coveredEmployees.forEach((d) => {
                    arryGowrningLaw.push(d.governingLaw)
                    arryGowrningLaw.forEach((element) => {
                        if (!uniqueGowrningLaw.includes(element)) {
                            uniqueGowrningLaw.push(element);
                        }
                    });
                    
                    
                    // eslint-disable-next-line react-hooks/exhaustive-deps, new-cap
                    // const arryGowrningLaw1 =  [...new arryGowrningLaw]
                    // console.log(unique);
                    if(d.governingDescription === 'State Act'){
                        // eslint-disable-next-line no-const-assign, react-hooks/exhaustive-deps
                        stateEmployeeTotal +=  parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
                        // eslint-disable-next-line react-hooks/exhaustive-deps
                        stateGrossPayTotal +=parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));
                    }
                    else if(d.governingDescription ===`United States Longshore and Harbor Workers' Compensation (USL&HW) Act` && (d?.auditedEmployeeCount || d?.auditedPayrollAmount)){
                        // eslint-disable-next-line no-const-assign, react-hooks/exhaustive-deps
                        longshoreAndHarborEmployeeTotal +=  parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
                        // eslint-disable-next-line react-hooks/exhaustive-deps
                        longshoreAndHarborGrossPayTotal += parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));

                    }else if(d.governingDescription ===`Admiralty Law (Jones Act or Merchant Marine Act of 1920) (Program I or Program II) ` && (d?.auditedEmployeeCount || d?.auditedPayrollAmount)){
                        // eslint-disable-next-line no-const-assign, react-hooks/exhaustive-deps
                        admiraltyLawEmployeeTotal += parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
                        // eslint-disable-next-line react-hooks/exhaustive-deps
                        admiraltyLawGrossPayTotal +=parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));

                    }else if(d.governingDescription ===`Federal Employers' Liability Act (FELA) (Program I or Program II) ` && (d?.auditedEmployeeCount || d?.auditedPayrollAmount)) {
                        // eslint-disable-next-line no-const-assign, react-hooks/exhaustive-deps
                        FELAEmployeeTotal += parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
                        // eslint-disable-next-line react-hooks/exhaustive-deps
                        FELAGrossPayTotal += parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));
                    
                    }
                })


            
                item.coveredEmployees.forEach((d) => {
                    if (holder.hasOwnProperty(d.governingDescription)) {
                        // eslint-disable-next-line operator-assignment
                        holder[d.governingDescription] = parseInt(holder[d.governingDescription]) + parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
                    } else {
                        holder[d.governingDescription] =  parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
                    }
                    

                });
            
                const obj2 = [];
            
                // eslint-disable-next-line guard-for-in
                for (const prop in holder) {
                    obj2.push({ name: prop, value: holder[prop] });
                }
                result.push(obj2);
                

                // eslint-disable-next-line array-callback-return
                const statetotalEmpCount = result[0].reduce((accum,itmVal) => accum + itmVal.value, 0)
                result[0].stateTotalEmpCount = statetotalEmpCount;
                
                const resultGrossPay = [];
        
                const holderGrossPay = {};
            
                item.coveredEmployees.forEach((d) => {
                    if (holderGrossPay.hasOwnProperty(d.governingDescription)) {
                        // eslint-disable-next-line operator-assignment
                        holderGrossPay[d.governingDescription] = parseInt(holderGrossPay[d.governingDescription]) + parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));
                    } else {
                        holderGrossPay[d.governingDescription] = parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));
                    }
                });
            
                const obj2GrossPay = [];
            
                // eslint-disable-next-line guard-for-in
                for (const prop in holderGrossPay) {
                    obj2GrossPay.push({ nameGrossPay: prop, valueGrossPay: holderGrossPay[prop] });
                }
                resultGrossPay.push(obj2GrossPay);
                const statetotalGrossTotl = resultGrossPay[0].reduce((accum,itmVl) => accum + itmVl.valueGrossPay, 0)
                resultGrossPay[0].statetotalGrossTotl = statetotalGrossTotl;
                
                return {
                    [`classCodeContainer${index}`]: {
                        data: item.coveredEmployees,
                        blankValues:blankValues
                    },
                    [`StateName${index}`]:{
                        content:getStates(item.stateCode)
                    },
                    [`empcount${index}`]:{
                        content:`${getStates(item.stateCode)} Employee Count`
                    },
                    [`stateTotalId${index}`]:{
                        content:`${getStates(item.stateCode)} State Total`
                    },
                    
                    [`stateempcountdata${index}`]:{
                        value:stateData.length!==0?`${stateData[index].empCount}`:`0`
                    },
                    [`stategrossamountdata${index}`]:{
                        amount:stateData.length!==0?stateData[index].grossAmount:0
                    },
                    [`grossamount${index}`]:{
                        content:`${getStates(item.stateCode)} Gross Pay Amount`
                    },
                
                    [`JuridictionStateTotal${index}`]:{
                        visible:result[0].findIndex((itm)=>itm.name ==='State Act')!==-1 
                    },

                    [`juriductionTotalsState${index}`]:{
                        value:result[0].find((itm)=>itm.name ==='State Act')?.value || `0`
                    },

                    [`stateActGrossPayAmount${index}`]:{
                        value:resultGrossPay[0].find((it)=>it.nameGrossPay ==='State Act')?.valueGrossPay || `0`
                    },
                    [`longshoreAndHarborDiv${index}`]:{
                        visible:result[0].findIndex((itm)=>itm.name ===`United States Longshore and Harbor Workers' Compensation (USL&HW) Act`)!==-1 
                    },

                    [`longshoreAndHarbor${index}`]:{
                        value:result[0].find((itm)=>itm.name ===`United States Longshore and Harbor Workers' Compensation (USL&HW) Act`)?.value || `0`
                    },
                    [`longshoreAndHarborGrossPayAmount${index}`]:{
                        value:resultGrossPay[0].find((it)=>it.nameGrossPay ===`United States Longshore and Harbor Workers' Compensation (USL&HW) Act`)?.valueGrossPay || `0`
                    },

                    [`admiraltyLawDiv${index}`]:{
                        visible:result[0].findIndex((itm)=>itm.name ===`Admiralty Law (Jones Act or Merchant Marine Act of 1920) (Program I or Program II) `)!==-1 
                    },

                    [`admiraltyLaw${index}`]:{
                        value:result[0].find((itm)=>itm.name ===`Admiralty Law (Jones Act or Merchant Marine Act of 1920) (Program I or Program II) `)?.value || `0`
                    },
                    [`admiraltyLawGrossPayAmount${index}`]:{
                        value:resultGrossPay[0].find((it)=>it.nameGrossPay ===`Admiralty Law (Jones Act or Merchant Marine Act of 1920) (Program I or Program II) `)?.valueGrossPay || `0`
                    },

                    [`FELADiv${index}`]:{
                        visible:result[0].findIndex((itm)=>itm.name ===`Federal Employers' Liability Act (FELA) (Program I or Program II) `)!==-1 
                    },

                    [`FELA${index}`]:{
                        value:result[0].find((itm)=>itm.name ===`Federal Employers' Liability Act (FELA) (Program I or Program II) `)?.value || `0`
                    },
                    [`FELAGrossPayAmount${index}`]:{
                        value:resultGrossPay[0].find((it)=>it.nameGrossPay ===`Federal Employers' Liability Act (FELA) (Program I or Program II) `)?.valueGrossPay || `0`
                    },

                    [`stateTotals${index}`]:{
                        visible:result[0].stateTotalEmpCount || resultGrossPay[0].statetotalGrossTotl 
                    },

                    [`stateTotalEmpCount${index}`]:{
                        value:result[0].stateTotalEmpCount || `0`
                    },

                    [`stateTotalGrossPay${index}`]:{
                        value:resultGrossPay[0].statetotalGrossTotl || `0`
                    },
                    // [`classCode${index}`]:{
                    //     className:appValue==='CE'?styles.CEclassCodeClClass:styles.classCodeClClass
                    // },
                    [`StateEmployeeCount${index}`]:{
                        className:appValue==='CE'?"headerClassCode":"headerClassCodePE"
                    },
                   

                    finaltotalStateAct:{
                        visible: uniqueGowrningLaw.indexOf("state") > -1
                    },
                    longshoreAndHarborBlock:{
                        visible:uniqueGowrningLaw.indexOf("longshoreAndHarbor") > -1
                    },
                    admiraltyLawBlock:{
                        visible:uniqueGowrningLaw.indexOf("admiraltyLaw") > -1
                    },

                    FELABlock:{
                        visible:uniqueGowrningLaw.indexOf("FELA") > -1
                    },
                    finaltotalStateActempcountdata:{
                        value: stateEmployeeTotal || `0`,
                        // visible:stateEmployeeTotal !== 0
                    },
            
                    finaltotalStateActgrossamountdata:{
                        value:stateGrossPayTotal || `0`,
                        // visible:stateGrossPayTotal !==0
                    },
                    // finaltotalStateActempcount:{
                    //     visible:(stateGrossPayTotal !==0 || stateEmployeeTotal !== 0)
                    // },
                    longshoreAndHarborTotalempcountdata:{
                        value:longshoreAndHarborEmployeeTotal || `0`,
                        // visible:longshoreAndHarborEmployeeTotal !==0
                    },
                    longshoreAndHarborTotalgrossamountdata:{
                        value:longshoreAndHarborGrossPayTotal || `0`,
                        // visible:longshoreAndHarborGrossPayTotal !==0
                    },
                    // totalempcount:{
                    //     visible:(longshoreAndHarborEmployeeTotal !==0 || longshoreAndHarborGrossPayTotal !==0)
                    // },

                    // totalempcountLabel:{   
                    //     visible:totalData.empCount !==0 || totalData.grossAmount !==0  
                    // },

                    admiraltyLawtotalempcountdata:{
                        // eslint-disable-next-line use-isnan
                        value:admiraltyLawEmployeeTotal || `0`,
                        // visible:admiraltyLawEmployeeTotal !==0
                    },
                    admiraltyLawtotalgrossamountdata:{
                        value:admiraltyLawGrossPayTotal || `0`,
                        // visible:admiraltyLawGrossPayTotal !==0
                    },
                    // admiraltyLawTotalempcount:{
                    //     visible:(admiraltyLawEmployeeTotal !==0 || admiraltyLawGrossPayTotal !==0)
                    // },
                    FELATotalempcountdata:{
                        value:FELAEmployeeTotal || `0`,
                        // visible:FELAEmployeeTotal !==0
                    },
                    FELATotalgrossamountdata:{
                        value:FELAGrossPayTotal || `0`,
                        // visible:FELAGrossPayTotal !==0
                    }, 
                    // FELATotalempcountId:{
                    //     visible:(FELAEmployeeTotal !==0 || FELAGrossPayTotal !==0)
                    // }
                   
                    
                };
                
            });
            
            return Object.assign({}, ...overrides);
        }
        // else{
        //     overrides = payrollData.coveredEmployees.map((item, index) => {
        //         return {
        //             [`classCodeContainer${index}`]: {
        //                 data: payrollData.coveredEmployees
        //             },
        //             [`StateName${index}`]:{
        //                 content:getStates(item.location.address.state)
        //             },
        //             [`empcount${index}`]:{
        //                 content:`${getStates(item.location.address.state)} Employee Count`
        //             },
        //             [`stateempcountdata${index}`]:{
        //                 value:stateData.length!==0?`${stateData[index].empCount}`:`0`
        //             },
        //             [`stategrossamountdata${index}`]:{
        //                 value:stateData.length!==0?`$${stateData[index].grossAmount}`:`$0`
        //             },
        //             [`grossamount${index}`]:{
        //                 content:`${getStates(item.location.address.state)} Gross Pay Amount`
        //             },
        //         };
        //     });   
        // }
        // [appValue, getStates, payrollData,stateData,randomNumber,viewStartPage]);
        
    }, [appValue, payrollData,stateData,randomNumber,viewStartPage,blankValues]);
    
    const DraftDataFromReview=useCallback((res)=>{
        setPayrollData(res)
    },[])

    const overrides = {
        premptionCard:{
            visible:PremptionError
        },
        pageContainer:{
            visible:viewStartPage && !PremptionError
        },
        payrollDetails:{
            data:getPayrollData(),
        },
        reportingperioddata:{
            value:getreportingperioddata()
        },
        totalempcountdata:{
            value:totalData.empCount || `0`,
            // visible:totalData.empCount !==0
        },
        totalgrossamountdata:{
            value:totalData.grossAmount || `0`,
            // visible:totalData.grossAmount !==0
        },
        // totalempcount:{
        //     visible:(totalData.empCount !==0 || totalData.grossAmount !==0)
        // },
        savedraftmsg:{
            content:getsaveDraftMsg(),
            visible:draftmsg
        },
        savedraftmsg2:{
            content:getsaveDraftMsg(),
            visible:draftmsg
        },
        thersholdwaring:{
            visible:totalData.grossAmount>payrollData.totalEstimatedPayrollThreshold,
        },
        review:{
            disabled:!stateData.every((i)=>Object.values(i).every((value)=>value>=0))|| disabledNext
        },
        
        // finaltotalStateAct:{
        //     visible:stateEmployeeTotal !==0 && stateGrossPayTotal !==0
        // },
        // longshoreAndHarborBlock:{
        //     visible:longshoreAndHarborEmployeeTotal !==0 && longshoreAndHarborGrossPayTotal !==0
        // },
        // admiraltyLawBlock:{
        //     visible:admiraltyLawEmployeeTotal !==0 && admiraltyLawGrossPayTotal !==0
        // },
        // FELABlock:{
        //     visible:FELAEmployeeTotal !==0 && FELAGrossPayTotal !==0
        // },
        payrollreview:{
            data: reviewData,
            appValue,
            visible:!viewStartPage && !_.isEmpty(reviewData)&& !PremptionError,
            onCallback:setviewStartPage,
            DraftDataFromReview
        },
        ...generateOverrides,
        // ...juridictionOverrides
    };

    
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleCancel:handleCancel,
            handleRefresh:handleRefresh,
            handleDraft:updateAuditReport,
            handleReview:handleReview,
            setUpdatedPayrollData:setUpdatedPayrollData,
            handleChangetoZero:handleChangetoZero,
            handlepremitionCancelBtn:handlepremitionCancelBtn
        },
        resolveComponentMap:{
            // classCodeComponent:(props?.lineOfBusinessDesc === "General Liability (v7)" || props?.lineOfBusinessCode === "GL7GeneralLiability")?CPMIClassCodeComponentGL:CPMIClassCodeComponent,
            classCodeComponent:CPMIClassCodeComponent,
            PayrollReview:PayrollReview
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

    return  <ViewModelForm
        uiProps={metadata.pageContent}
        model={payrollData}
        overrideProps={overrides}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
        callbackMap={resolvers.resolveCallbackMap}
    />
}

CPMIStartPayroll.defaultProps = {};
export default withRouter(CPMIStartPayroll);